import axiosInstance from '../axiosInterceptor/axiosInstance'

const addTeam = async (data) => {
  const { orgId, ...restData } = data
  const url = `v1/orgs/${orgId}/teams`
  return axiosInstance.post(url, restData)
}

export default addTeam
